/**
 * ImageHero Component
 *
 * Hero section with icon, title, and description for the image generation page.
 */

import { memo } from 'react';
import { ImageIcon } from 'lucide-react';
import { useTranslation } from '../../hooks/useTranslation';

export const ImageHero = memo(function ImageHero() {
  const { t } = useTranslation();

  return (
    <div className="text-center mb-6 md:mb-8">
      <div className="inline-flex items-center justify-center w-12 h-12 md:w-16 md:h-16 bg-gradient-to-r from-purple-600 to-pink-600 rounded-xl md:rounded-2xl mb-3 md:mb-4">
        <ImageIcon className="h-6 w-6 md:h-8 md:w-8 text-white" />
      </div>
      <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-secondary-900 dark:text-white mb-2">
        {t('image.hero.title', { defaultValue: 'AI Image Generation' })}
      </h2>
      <p className="text-sm sm:text-base md:text-lg text-secondary-600 dark:text-secondary-300 max-w-2xl mx-auto px-2">
        {t('image.hero.description', {
          defaultValue: 'Create stunning images from text descriptions using advanced AI models',
        })}
      </p>
    </div>
  );
});
